<ng-container *ngIf="viewModel$ | async as vm">
  <div class="form-group row">
    <div class="col-12">
      <input id="filter" type="search" class="form-control" [formControl]="filter" placeholder="Filter..." />
    </div>
  </div>
  <table class="table mt-2 table-bordered table-striped">
    <thead>
      <tr>
        <th>Category</th>
        <th>Question</th>
        <th>Answer</th>
        <th>Used</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let question of vm.questions; trackBy: faqById">
        <tr>
          <td>{{ question.category }}</td>
          <td>{{ question.question }}</td>
          <td [innerHTML]="question.answer | safe: 'html'"></td>
          <td>
            <input type="checkbox" title="Caller has asked this question" [checked]="question.historyId !== 0"
              (change)="logQuestionHistory(question.qaId)" />
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</ng-container>